import { storyblokEditable } from "@storyblok/react";
const GastroforumBigPicture = ({ blok }) => {
  return (
    <div className="wrap">
         <div className="gastroforum-wrap inner-wrap" {...storyblokEditable(blok)}>
      <img src={blok.image.filename} alt={blok.image.alt} />
      </div>
    </div>
     
  );
};
export default GastroforumBigPicture;




